import React from "react";
import GenericDialog from "@components/GenericDialog/GenericDialog";
import { t } from "i18next";
import type { ConfirmUnclaimDialogProps } from "./ConfirmUnclaimDialog.types";

const ConfirmUnclaimDialog: React.FC<ConfirmUnclaimDialogProps> = (props) => {
  const { isBulk, isOpen, setIsOpen, confirmAction, testId, languageBase } = props;

  const title = isBulk
    ? t(`${languageBase}.bulk-unclaim-confirm-title`)
    : t(`${languageBase}.unclaim-confirm-title`);
  const elementContent = isBulk ? (
    <>
      {t(`${languageBase}.bulk-unclaim-confirm-message`, {
        count: props.count,
      })}
      <br />
      {t("common.are-you-sure-question")}
    </>
  ) : (
    <>
      {t(`${languageBase}.unclaim-confirm-message`)} <strong>#{props.itemId}</strong>.
      <br />
      {t("common.are-you-sure-question")}
    </>
  );

  return (
    <GenericDialog
      open={isOpen}
      title={title}
      elementContent={elementContent}
      cancelButtonText={t("common.cancel")}
      confirmButtonText={t("common.unclaim")}
      handleCloseDialog={() => setIsOpen(false)}
      confirmAction={confirmAction}
      testId={testId}
    />
  );
};

export default ConfirmUnclaimDialog;
